import { customerMarketShopfrontJobsApi, Site } from '@envato/foundation-types'
import * as React from 'react'
import { connect } from 'react-redux'
import { RouteConfigComponentProps } from 'react-router-config'

import {
  fetchFeaturedPageDataBySite,
  IFeaturedPageSeoMetaData,
  onBeforeFeaturePageView
} from '../../common/actions/featurePage'
import { IRootState } from '../../common/reducers'
import { IEnhancedLocation } from '../../common/reducers/reactRouterLocation'
import { decorateSearchResult } from '../../common/selectors/searchResults'
import { IPageComponent } from '../../typings/pageComponent'
import { IItem } from '../../typings/searchResults'
import TopSellersPage from '../pages/topSellers/topSellersPage'

interface IOwnProps extends RouteConfigComponentProps<any> {
  location: any // TODO: REMOVE THIS WHEN LOCATION IS NOT ADDING QUERY
}

interface IStateProps {
  metadata?: IFeaturedPageSeoMetaData
  items: IItem[]
  featuredAuthors: customerMarketShopfrontJobsApi.IFeaturedAuthorsResult
  location: IEnhancedLocation
  experimentsReady: boolean
  isLoading: boolean
  currentSite: Site
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const {
    featuredPage: {
      featuredItems: featuredItemsMatches,
      featuredAuthors,
      isLoading,
      metadata
    }
  } = state
  const { location } = state.router
  const { experimentsReady } = state.experiments
  const { currentSite } = state.common

  const items =
    (featuredItemsMatches &&
      featuredItemsMatches.matches.map(match =>
        decorateSearchResult(state, match)
      )) ||
    []

  return {
    metadata,
    items,
    featuredAuthors: featuredAuthors || [],
    location,
    experimentsReady,
    currentSite,
    isLoading
  }
}

export type Props = IOwnProps & IStateProps

const createTopSellersPageContainer = (
  component: React.ComponentType<Props>
) => {
  const pageComponent: IPageComponent<Props> = component as IPageComponent<
    Props
  >

  pageComponent.loadData = (store, location, apiUrlPrefix) =>
    store.dispatch(fetchFeaturedPageDataBySite(location, apiUrlPrefix))

  pageComponent.onBeforePageView = store =>
    store.dispatch(onBeforeFeaturePageView())

  return connect<IStateProps, null, IOwnProps, IRootState>(mapStateToProps)(
    pageComponent
  )
}

export default createTopSellersPageContainer(TopSellersPage)
